import linkifyIt from '../../../../../linkify-it/index.js';

var whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    /^notes:/im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
];
var isSafeUrl = function (url) {
    return whitelistedURLPatterns.some(function (p) { return p.test(url.trim()) === true; });
};
var linkify = linkifyIt();
linkify.add('sourcetree:', 'http:');
function getLinkMatch(str) {
    var match = str && linkify.match(str);
    return match && match[0];
}
/**
 * Adds protocol to url if needed.
 */
function normalizeUrl(url) {
    var match = getLinkMatch(url);
    return (match && match.url) || url;
}

export { getLinkMatch, isSafeUrl, normalizeUrl };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/utils/url.js